import Select from './src/index.vue'

Select.install = (Vue) => {
  Vue.component(Select.name, Select)
}

export default Select
